// extracted by mini-css-extract-plugin
export default {"tables":"HomePage_tables__9CcVf","table":"HomePage_table__99YQJ","homePage":"HomePage_homePage__JskKV","boldText":"HomePage_boldText__Ccs4+"};